import { CLOSE_MODERATE_TRAY, OPEN_MODERATE_TRAY } from '@instructure/quiz-common';
export function closeTray() {
  return {
    type: CLOSE_MODERATE_TRAY
  };
}
export function openTray(participant) {
  return {
    type: OPEN_MODERATE_TRAY,
    participant: participant
  };
}